<template>
  <div>
    <v-row>
      <v-col cols="12">
        <h2>Account Overview</h2>
      </v-col>
      <v-col cols="12" sm="12" md="4" lg="4">
        <v-card class="primary">
          <v-card-text>
            <v-row justify="center" align="center">
              <v-col cols="12">
                <h3 class="white--text">Active Subscription</h3>
              </v-col>
              <v-col cols="9">
                <v-icon size="50" color="white">mdi-play-circle</v-icon>
              </v-col>
              <v-col cols="3" class="text-right">
                <h1 class="white--text accountOverviewh1">{{ activeCount }}</h1>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="12" sm="12" md="4" lg="4">
        <v-card class="secondary">
          <v-card-text>
            <v-row justify="center" align="center">
              <v-col cols="12">
                <h3 class="white--text">Paused Subscription</h3>
              </v-col>
              <v-col cols="9">
                <v-icon size="50" color="white">mdi-pause</v-icon>
              </v-col>
              <v-col cols="3" class="text-right">
                <h1 class="white--text accountOverviewh1">{{ pausedCount }}</h1>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="12" sm="12" md="4" lg="4">
        <v-card class="compeatthird">
          <v-card-text>
            <v-row justify="center" align="center">
              <v-col cols="12">
                <h3 class="white--text">Cancelled Subscriptions</h3>
              </v-col>
              <v-col cols="9">
                <v-icon size="50" color="white">mdi-cancel</v-icon>
              </v-col>
               <v-col cols="3" class="text-right">
                <h1 class="white--text accountOverviewh1">{{ cancelledCount }}</h1>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="12" sm="12" md="4" lg="4">
        <v-card class="compeatthird">
          <v-card-text>
            <v-row justify="center" align="center">
              <v-col cols="12">
                <h3 class="white--text">Demo Subscriptions</h3>
              </v-col>
              <v-col cols="9">
                <v-icon size="50" color="white">mdi-test-tube</v-icon>
              </v-col>
               <v-col cols="3" class="text-right">
                <h1 class="white--text accountOverviewh1">{{ demoCount }}</h1>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  props: ["allAgencySubscriptions"],
  data: () => ({}),
  computed: {
    activeCount() {
      return this.allAgencySubscriptions.filter(
        (subscription) => subscription.paypalData?.status === "ACTIVE"
      ).length;
    },
    pausedCount() {
      return this.allAgencySubscriptions.filter(
        (subscription) => subscription.paypalData?.status === "SUSPENDED"
      ).length;
    },
    cancelledCount() {
      return this.allAgencySubscriptions.filter(
        (subscription) => subscription.paypalData?.status === "CANCELLED"
      ).length;
    },
    demoCount() {
      return this.allAgencySubscriptions.filter(
        (subscription) => subscription.package.packageType === "Compeat Demo Subscription"
      ).length;
    },
  },
};
</script>

<style>
.accountOverviewh1 {
  font-size: 50px;
}
</style>
